var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guidelines-&-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-203.000000, -177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ic-/-Book",
    transform: "translate(203.000000, 177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "globe-(1)",
    transform: "translate(2.000000, 2.000000)",
    stroke: "#00CB85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C12.5012804,2.73835289 13.9227528,6.29203385 14,10 C13.9227528,13.7079661 12.5012804,17.2616471 10,20 C7.49871962,17.2616471 6.07724724,13.7079661 6,10 C6.07724724,6.29203385 7.49871962,2.73835289 10,0 L10,0 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.108888c3.svg";
export { ForwardRef as ReactComponent };